import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  progress: number;
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  progress,
  currentStep,
  totalSteps
}: ProgressBarProps) {
  return <div className="w-full max-w-xl mx-auto px-4" data-id="element-83">
      <div className="flex items-center justify-between mb-2" data-id="element-84">
        <span className="text-xs text-cyan-300/70 font-medium tracking-wide uppercase" data-id="element-85">
          Pregunta {currentStep} de {totalSteps}
        </span>
        <span className="text-xs text-white/40 font-mono" data-id="element-86">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-2 w-full rounded-full bg-white/5 border border-white/10 overflow-hidden" data-id="element-87">
        <motion.div className="h-full rounded-full" style={{
        background: 'linear-gradient(90deg, #00d4ff 0%, #0ea5e9 50%, #00d4ff 100%)',
        boxShadow: '0 0 12px rgba(0, 212, 255, 0.4)'
      }} initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        type: 'spring',
        stiffness: 80,
        damping: 20
      }} data-id="element-88" />
      </div>
    </div>;
}